import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patrones-wltp',
  templateUrl: './patrones-wltp.component.html',
  styleUrls: ['./patrones-wltp.component.sass']
})
export class PatronesWltpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
